import React from "react";

export default function FitAllIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="currentColor">
          <g>
            <g>
              <g>
                <path
                  d="M2 2L2 20.997 2.002 2z"
                  transform="translate(-1260 -1652) translate(1244 1652) translate(16) translate(10 10)"
                />
                <path
                  d="M0 0L0 23 2 23 2 21.001 2 3.415 21.293 22.707 22.707 21.293 3.414 2.001 21 2.001 23 2.001 23 0zM37 0L37 2.001 39 2.001 56.586 2.001 37.293 21.293 38.707 22.707 58 3.415 58 21.001 58 23 60 23 60 0zM0 37L0 60 23 60 23 58.001 21 58.001 3.414 58.001 22.707 38.707 21.293 37.293 2 56.587 2 39.001 2 37zM58 37L58 39.001 58 56.587 38.708 37.293 37.294 38.707 56.586 58.001 39 58.001 37 58.001 37 60 60.001 60 60.001 37z"
                  transform="translate(-1260 -1652) translate(1244 1652) translate(16) translate(10 10)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
